import { Component } from '@angular/core'

@Component({
  selector: '[app-field-columns]',
  styles: `
    :host {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr;

        @media (min-width: 768px) {
            grid-template-columns: 1fr 1fr;
            column-gap: 0.5rem;
        }

        @media (min-width: 992px) {
            grid-template-columns: 1fr 1fr 1fr;
            column-gap: 1rem;
        }

        @media (min-width: 1200px) {
            grid-template-columns: 1fr 1fr 1fr 1fr;
            column-gap: 2rem;
        }
    }`,
  template: '<ng-content></ng-content>',
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class FieldColumnsComponent {}
